var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slim-profile"},[_c('slim-cropper',{attrs:{"options":_vm.slimOptions}},[_c('input',{attrs:{"type":"file","name":"avatar_location[]"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }